import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_written_policies_andor_formal_procedures_for'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_written_policies_andor_formal_procedures_for',
  name: 'Does the facility have written policies and/or formal procedures for social and labor practices?',
  description:
    'The intent of this option selection is to understand if the facility has written policies or procedures (written or informal) in place related to social and labor practices.\r\r\n\r\r\n"Social and labor practices" refers to topics mentioned throughout this tool. Such as:\r\r\n\r\r\nRecruitment & hiring, termination, child labor & young workers, forced labor, harassment and abuse, discrimination, working hours, wages and benefits, discipline, FOA & CB, grievance systems, etc.',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'WRITTEN_POLICIES',
      text: 'Written Policies',
      externalIds: [
        {
          id: 'ms-1-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all relevant written policies:',
        externalIds: [
          {
            id: 'ms-pla-2f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'WRITTEN_PROCEDURES',
      text: 'Written Procedures',
      externalIds: [
        {
          id: 'ms-1-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all relevant written procedures:',
        externalIds: [
          {
            id: 'ms-pla-3f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NO_WRITTEN_POLICIES_OR_PROCEDURES_IN_PLACE_BUT_INFORMAL_PROCEDU',
      text: 'No written policies or procedures in place (but informal procedures may exist)',
      externalIds: [
        {
          id: 'ms-1-3x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe these informal procedures:',
        externalIds: [
          {
            id: 'ms-pla-4f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'ARE_POLICIES_AND_OR_PROCEDURES_ENDORSED_BY_SENIOR_MANAGEMENT_',
      text: 'Are policies and/or procedures endorsed by Senior Management?',
      externalIds: [
        {
          id: 'ms-pla-65',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'WRITTEN_POLICIES',
                'WRITTEN_PROCEDURES',
                'NO_WRITTEN_POLICIES_OR_PROCEDURES_IN_PLACE_BUT_INFORMAL_PROCEDU',
                'ARE_POLICIES_AND_OR_PROCEDURES_ENDORSED_BY_SENIOR_MANAGEMENT_',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 18180,
  sectionId: '2.2.6.10',
  impactArea: 'Policies and Procedures',
  impactAreaId: 'POLICIES_AND_PROCEDURES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
